import { Reveal } from "../Reveal";
import { HOW_IT_WORKS_STEPS } from "../../config/site";

export const HowItWorks = () => (
  <section id="how-it-works" className="border-y border-ink-line bg-ink-surface py-24 sm:py-32" data-testid="how-it-works-section">
    <div className="mx-auto max-w-6xl px-6">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-accent">Process</p>
        <h2 className="mt-4 font-display text-3xl uppercase leading-none tracking-tight text-ink-text sm:text-4xl lg:text-5xl">
          Three steps. Zero guesswork.
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-px border border-ink-line bg-ink-line md:grid-cols-3">
        {HOW_IT_WORKS_STEPS.map((step, i) => (
          <div key={step.number} className="bg-ink-surface p-8 sm:p-10" data-testid={`how-it-works-step-${i + 1}`}>
            <Reveal delay={i * 0.12}>
              <span className="font-mono text-6xl font-bold tracking-tight text-accent/90">{step.number}</span>
              <h3 className="mt-6 text-xl font-bold tracking-tight text-ink-text sm:text-2xl">{step.title}</h3>
              <p className="mt-4 leading-relaxed text-ink-muted">{step.body}</p>
            </Reveal>
          </div>
        ))}
      </div>
    </div>
  </section>
);
